import { Component, OnInit } from '@angular/core';
import { LectionaryTrackService } from '../../services/lectionary-track.service';
import { LectionaryTrack } from '../lectionary-track/lectionary-track.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-lectionary-track-edit',
  templateUrl: './lectionary-track-edit.component.html',
  styleUrls: ['./lectionary-track-edit.component.css']
})
export class LectionaryTrackEditComponent implements OnInit {

  public item: LectionaryTrack;
  public listsLoaded: boolean;

  constructor(
    private lectionaryTrackSvc: LectionaryTrackService,
    private dialog: MatDialogRef<LectionaryTrackEditComponent>
  ) { }


  ngOnInit() {
  }


  public LoadItem(itemId: number) {
    if (itemId) {
      this.lectionaryTrackSvc.getItem(itemId).then(
        (data: LectionaryTrack) => {
          this.item = data;
          this.listsLoaded = true;
          console.log(data);
       //   this.currentLocalizedData = this.item.Localized[0];
        }
      )
    }
  }



  private setModelValue(value: any, target: any) {

    if (target == null) {
      target = {
        Id: value
      };
    } else {
      target.Id = value;
    }

    return target;

  }

  public cancel() {
    this.dialog.close();
  }

  public save() {
    console.log(this.item);

    this.lectionaryTrackSvc.save(this.item).then(
      (data) => {
        console.log(data);
        this.dialog.close(data);
      }
    ).catch(
      (err) => {
        console.log("error", err);
      }
    )

  }

}
